import React, { useEffect } from "react";
import { buttonText } from "../constants/ConstantsVariable";
import OrderSummaryBoxComp from "./shares/OrderSummaryBoxComp";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CommonButton from "./shares/CommonButton";
import { getProviderData } from "../../../Apimanager/Networking";
import HeaderCompNew from "./shares/newHeaderComp";
const PaymentStatusComp = (props) => {
   const { name, subscription_interval } = props;
   const navigateFun = () => {
      localStorage.setItem("trialEndedRedirection", "true");
      window.location.href = "/notes";
   };
   const text = {
      title: "Welcome to Playback Pro!",
      para: `Thank you for choosing Playback Pro ${subscription_interval?.interval} Subscription!`,
   };

   useEffect(() => {
      getProviderData(null, true);
   }, []);

   return (
      <div className="pg-final-aline-container-sucess-new-ui d-relative">
         <HeaderCompNew
            text={text}
            isDone={true}
            selectPlans={subscription_interval?.interval}
            name={name}
            isSucess={true}
         />
         <div className="pg-subscription-plan-container">
            <OrderSummaryBoxComp selectPlans={subscription_interval} />
         </div>
         <div>
            <div className="pg-button-margin-container-new-ui">
               <CommonButton
                  id="signUp-button-v2"
                  btnText={buttonText(5)}
                  onClick={navigateFun}
                  loading={false}
                  isWhiteBtn={false}
               />
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => ({
   subscription_interval: state?.auth?.subscriptionInterval,
   name: state?.auth?.userCredentials?.user?.name || {},
});

export default withRouter(connect(mapStateToProps)(PaymentStatusComp));
